// Tiny relative-time formatter for the "Last seen" column.
// Uses Intl.RelativeTimeFormat. EN/FR locales handled by the BCP-47 tag.
//
// Inputs are ISO-8601 strings from the API (always UTC). We do the diff in
// the user's local clock; close enough for the "14 min ago" UX in the table.

export function formatRelativeTime(iso: string, locale: 'en' | 'fr' = 'en'): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '—';
  const diffSec = Math.round((then - Date.now()) / 1000);
  const abs = Math.abs(diffSec);
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
  if (abs < 60) return rtf.format(diffSec, 'second');
  if (abs < 3600) return rtf.format(Math.round(diffSec / 60), 'minute');
  if (abs < 86_400) return rtf.format(Math.round(diffSec / 3600), 'hour');
  if (abs < 30 * 86_400) return rtf.format(Math.round(diffSec / 86_400), 'day');
  if (abs < 365 * 86_400) return rtf.format(Math.round(diffSec / (30 * 86_400)), 'month');
  return rtf.format(Math.round(diffSec / (365 * 86_400)), 'year');
}
